import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import SectionBg from '../components/SectionBg';
import { recipes, contest } from '../data/recipes';

const steps = [
  { icon: 'ti-upload', title: 'Soumets ta recette', text: 'Partage ta création à base de Tartina avec photo, ingrédients et étapes.' },
  { icon: 'ti-heart', title: 'Fais-la voter', text: 'Ta recette entre au classement : la communauté vote pour ses préférées.' },
  { icon: 'ti-trophy', title: 'Gagne', text: 'Les recettes les mieux notées et les plus populaires du mois remportent les lots.' },
];

const ContestPage = () => {
  const ranking = [...recipes].sort((a, b) => b.votes - a.votes);
  const [votes, setVotes] = useState({});
  const toggle = (id) => setVotes((v) => ({ ...v, [id]: !v[id] }));
  const voteCount = (r) => r.votes + (votes[r.id] ? 1 : 0);

  return (
    <>
      <Hero>
        <SectionBg tone="white" variant={1} />
        <Inner>
          <Eyebrow><i className="ti ti-trophy" aria-hidden="true" /> Jeu-concours · {contest.month}</Eyebrow>
          <h1>{contest.title}</h1>
          <p>
            Propose ta plus belle recette à la Tartina, fais-la voter et tente de remporter
            le grand prix du mois. Les meilleures recettes deviennent gagnantes.
          </p>
          <Prizes>
            <PrizeCard><i className="ti ti-gift" /><b>{contest.prize}</b><span>à gagner</span></PrizeCard>
            <PrizeCard><i className="ti ti-calendar-event" /><b>{contest.deadline}</b><span>clôture</span></PrizeCard>
            <PrizeCard><i className="ti ti-users" /><b>{contest.participants}</b><span>participants</span></PrizeCard>
          </Prizes>
          <SubmitBtn to="/add-recipe?concours=1"><i className="ti ti-upload" aria-hidden="true" /> Soumettre ma recette</SubmitBtn>
        </Inner>
      </Hero>

      <Inner>
        <SectionTitle>Comment ça marche ?</SectionTitle>
        <Stepss>
          {steps.map((s, i) => (
            <StepCard key={s.title}>
              <StepNum>{i + 1}</StepNum>
              <StepIcon><i className={`ti ${s.icon}`} aria-hidden="true" /></StepIcon>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </StepCard>
          ))}
        </Stepss>

        <SectionTitle>Classement du mois</SectionTitle>
        <Board>
          {ranking.map((r, i) => (
            <Row key={r.id} $top={i < 3}>
              <Rank $rank={i + 1}>{i < 3 ? <i className="ti ti-crown" aria-hidden="true" /> : i + 1}</Rank>
              <Thumb to={`/recipes/${r.id}`}><img src={r.image} alt="" /></Thumb>
              <RowInfo>
                <RowName to={`/recipes/${r.id}`}>{r.name}</RowName>
                <RowMeta>
                  <span><i className="ti ti-user" aria-hidden="true" /> {r.author}</span>
                  <span><i className="ti ti-star" aria-hidden="true" /> {r.rating.toFixed(1)}</span>
                </RowMeta>
              </RowInfo>
              <Votes>
                <b>{voteCount(r).toLocaleString('fr-FR')}</b>
                <span>votes</span>
              </Votes>
              <VoteBtn $on={!!votes[r.id]} onClick={() => toggle(r.id)} aria-label="Voter">
                <i className={votes[r.id] ? 'ti ti-check' : 'ti ti-heart'} aria-hidden="true" />
                {votes[r.id] ? 'Voté' : 'Voter'}
              </VoteBtn>
            </Row>
          ))}
        </Board>

        <Cta>
          <div>
            <h2>Prêt·e à tenter ta chance ?</h2>
            <p>La soumission est gratuite et ouverte à tous. À tes fourneaux !</p>
          </div>
          <SubmitBtn to="/add-recipe?concours=1"><i className="ti ti-upload" aria-hidden="true" /> Participer maintenant</SubmitBtn>
        </Cta>
      </Inner>
    </>
  );
};

const Hero = styled.section`
  background: ${({ theme }) => theme.colors.primary};
  padding: 48px 0 44px; color: #fff;
  position: relative; isolation: isolate;
  h1 { color: #fff; font-size: clamp(2rem, 4.4vw, 3rem); margin: 12px 0 12px; }
  p { color: rgba(255,255,255,0.92); max-width: 58ch; margin: 0 0 24px; font-size: 1.05rem; }
`;
const Inner = styled.div`max-width: 1100px; margin: 0 auto; padding: 0 24px;`;
const Eyebrow = styled.span`
  display: inline-flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.18);
  color: #fff; font-weight: 800; font-size: 0.82rem; padding: 6px 14px; border-radius: 999px;
`;
const Prizes = styled.div`display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 26px;`;
const PrizeCard = styled.div`
  background: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.22);
  border-radius: 16px; padding: 14px 20px; display: flex; flex-direction: column;
  i { font-size: 1.4rem; color: ${({ theme }) => theme.colors.secondary}; margin-bottom: 4px; }
  b { font-family: ${({ theme }) => theme.fonts.heading}; font-size: 1.2rem; }
  span { font-size: 0.8rem; color: rgba(255,255,255,0.8); }
`;
const SubmitBtn = styled(Link)`
  display: inline-flex; align-items: center; gap: 8px; text-decoration: none;
  background: ${({ theme }) => theme.colors.secondary}; color: ${({ theme }) => theme.colors.chocolate};
  font-weight: 800; font-size: 1rem; padding: 14px 24px; border-radius: 999px; transition: all .2s ease;
  &:hover { background: ${({ theme }) => theme.colors.secondaryDark}; transform: translateY(-2px); }
`;
const SectionTitle = styled.h2`
  font-size: 1.8rem; color: ${({ theme }) => theme.colors.chocolate}; margin: 48px 0 22px;
`;
const Stepss = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px;
`;
const StepCard = styled.div`
  position: relative; background: #fff; border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 20px; padding: 26px 22px;
  h3 { font-size: 1.2rem; color: ${({ theme }) => theme.colors.chocolate}; margin-bottom: 6px; }
  p { color: ${({ theme }) => theme.colors.textSecondary}; margin: 0; font-size: 0.95rem; }
`;
const StepNum = styled.span`
  position: absolute; top: 18px; right: 18px; font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 700; font-size: 2rem; color: ${({ theme }) => theme.colors.cream};
`;
const StepIcon = styled.div`
  width: 54px; height: 54px; border-radius: 16px; background: ${({ theme }) => theme.colors.cream};
  display: flex; align-items: center; justify-content: center; margin-bottom: 14px;
  i { font-size: 1.6rem; color: ${({ theme }) => theme.colors.primary}; }
`;
const Board = styled.div`
  background: #fff; border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: 20px; overflow: hidden;
`;
const Row = styled.div`
  display: flex; align-items: center; gap: 14px; padding: 14px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ $top, theme }) => ($top ? theme.colors.background : '#fff')};
  &:last-child { border-bottom: none; }
`;
const Rank = styled.span`
  flex: none; width: 36px; height: 36px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center; font-weight: 800;
  font-family: ${({ theme }) => theme.fonts.heading};
  background: ${({ $rank, theme }) =>
    $rank === 1 ? theme.colors.secondary : $rank === 2 ? '#E9E2D2' : $rank === 3 ? '#F3D9C0' : theme.colors.background};
  color: ${({ theme }) => theme.colors.chocolate};
  i { font-size: 1.1rem; }
`;
const Thumb = styled(Link)`
  flex: none; img { width: 56px; height: 56px; border-radius: 12px; object-fit: cover; display: block; }
`;
const RowInfo = styled.div`flex: 1; min-width: 0;`;
const RowName = styled(Link)`
  display: block; text-decoration: none; font-weight: 800; color: ${({ theme }) => theme.colors.chocolate};
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  &:hover { color: ${({ theme }) => theme.colors.primary}; }
`;
const RowMeta = styled.div`
  display: flex; gap: 14px; color: ${({ theme }) => theme.colors.textSecondary}; font-size: 0.82rem;
  span { display: inline-flex; align-items: center; gap: 4px; }
  i { color: ${({ theme }) => theme.colors.secondaryDark}; }
`;
const Votes = styled.div`
  flex: none; text-align: right; display: none;
  b { font-family: ${({ theme }) => theme.fonts.heading}; color: ${({ theme }) => theme.colors.chocolate}; }
  span { display: block; font-size: 0.72rem; color: ${({ theme }) => theme.colors.textSecondary}; }
  @media (min-width: 560px) { display: block; }
`;
const VoteBtn = styled.button`
  flex: none; display: inline-flex; align-items: center; gap: 6px; cursor: pointer;
  border: 2px solid ${({ $on, theme }) => ($on ? theme.colors.success : theme.colors.primary)};
  background: ${({ $on, theme }) => ($on ? theme.colors.success : '#fff')};
  color: ${({ $on, theme }) => ($on ? '#fff' : theme.colors.primary)};
  font-weight: 800; font-size: 0.85rem; padding: 8px 16px; border-radius: 999px; transition: all .15s ease;
`;
const Cta = styled.section`
  margin: 48px 0 8px; background: ${({ theme }) => theme.colors.secondary};
  border-radius: 24px; padding: 30px 32px;
  display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap;
  h2 { font-size: 1.6rem; color: ${({ theme }) => theme.colors.chocolate}; margin-bottom: 4px; }
  p { margin: 0; color: ${({ theme }) => theme.colors.chocolate}; opacity: 0.85; }
`;

export default ContestPage;
